import { ElectionListResponse } from '~/definitions/election';
import { getStore } from '~/mobx/AppStore';

const fetchElectionData = (data: ElectionListResponse) => {
    const { generalSettingsStore } = getStore();
    const { election = {}, electionList = [], isDisabled = false } = data;
    const latestElectionId = electionList?.[0]?.id || '';
    const electionId = election?.id || '';

    generalSettingsStore.setIsSettingsDisabled(isDisabled);
    generalSettingsStore.setLatestElectionId(latestElectionId);
    generalSettingsStore.setPreSelectElectionId(electionId);
    generalSettingsStore.setSelectedElectionId(electionId);
    generalSettingsStore.setSelectedElectionData(election);
    generalSettingsStore.setElectionList(electionList);
};

export default fetchElectionData;
